import PageHeader from "../../components/PageHeader";
import CustomButton from "../../components/CustomButton";
import QueryApis from "../../api/QueryApis";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import QueryForm from "../../components/QueryForm";
import { FormRenderConfig } from "../../components/FromFieldRenderer";
import { useQueryForm } from "../../util/hooks/useQueryForm";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function AddQueries() {
  const branchcode = useBranchCode();
  const { formFields, formData, setFormData, handleChange, isFormValid } =
    useQueryForm(branchcode);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const payload = { ...formData, branchCode: branchcode };

      await QueryApis.createQuery(payload);

      toast.success("Query added successfully!");
      navigate("/queries");
    } catch (err) {
      toast.error("Failed to add Query");
    }
  };

  const config: FormRenderConfig = {
    radioOnlyFor: ["gender"],
    imageVariant: "compact",
  };

  return (
    <div className="flex flex-col gap-4">
      <PageHeader showBack />
      <form
        className="bg-white rounded-lg px-6 py-7 grid gap-7"
        onSubmit={handleSubmit}
      >
        <section className="grid md:grid-cols-2 gap-7 auto-rows-min">
          <QueryForm
            fields={formFields}
            formData={formData}
            onChange={handleChange}
            setFormData={setFormData}
            config={config}
          />
        </section>

        <span className="flex justify-end items-end text-error-500 font-medium text-xs">
          *By submitting, you agree to receive communication messages through
          Email/Whatsapp/SMS
        </span>

        <div className="flex justify-end items-end mt-6">
          <CustomButton
            type="submit"
            text="Submit Query"
            color="bg-primary-500"
            disabled={!isFormValid}
          />
        </div>
      </form>
    </div>
  );
}
